module.exports = __webpack_public_path__ + "img/CustomizeYourMapView.b04a3302.svg";